const PLAYER_STORAGE_KEY_PREFIX = 'hijack_perfhud:player:';
const inMemoryPreferences = new Map<string, boolean>();
export const PERF_HUD_TOGGLE_EVENT = 'perf-hud-toggle';

export const isPlayerPerfHudEnabled = (playerGUID: string): boolean => {
  if (!playerGUID) return false;
  try {
    return window.localStorage.getItem(`${PLAYER_STORAGE_KEY_PREFIX}${playerGUID}`) === '1';
  } catch {
    return inMemoryPreferences.get(playerGUID) ?? false;
  }
};

export const setPlayerPerfHudEnabled = (playerGUID: string, next: boolean): void => {
  if (!playerGUID) return;
  inMemoryPreferences.set(playerGUID, next);
  try {
    window.localStorage.setItem(`${PLAYER_STORAGE_KEY_PREFIX}${playerGUID}`, next ? '1' : '0');
  } catch {
    // localStorage unavailable — the module fallback remains authoritative for this session.
  }
  window.dispatchEvent(new Event(PERF_HUD_TOGGLE_EVENT));
};
